// Preview-only capability policy. Full-report map generation remains enabled in the backend.
export const PREVIEW_DATA_LAYER_MAPS_ENABLED = false;
